import type { ComponentProps } from './ComponentProps';

const alreadyWarned = new Set<string>();

export function getClassNameOverride(
  props: ComponentProps<unknown>,
  componentName?: string,
) {
  const className = props.dangerouslyOverrideClassName?.__className;

  if (!className) {
    return undefined;
  }

  if (
    import.meta.env.DEV &&
    (!componentName || !alreadyWarned.has(componentName))
  ) {
    console.warn(
      `className is not allowed to be passed to Chords components.${componentName ? ` [${componentName}]` : ''}`,
    );
  }

  if (componentName) {
    alreadyWarned.add(componentName);
  }

  delete props.dangerouslyOverrideClassName;

  return className;
}
